import React from "react";
import { bool, string } from "prop-types";
import { Modal, Row, Col, Button } from "react-bootstrap";
import queryString from "query-string";
import { removeLoginTokenLinkedIn } from "../actions";
import criteriaLinkedInIntegrationImage from "../../../resources/images/criteria_linkedin.png";
import { linkedInErrorMessaging } from "../helpers";

const LinkedInIntegrationErrorModal = ({
  showLinkedInIntegrationErrorModal,
  linkedInUserEmail,
  linkedInIntegrationErrorMessage,
  loginToken,
}) => {
  const queryParams = queryString.parse(window.location.search);

  const handleReturnToLinkedInTalentHub = () => {
    // use redirectUrl parameter in the query string to redirect to LinkedIn Talent Hub
    window.location.href = queryParams.redirectUrl;
  };

  const handleRouteUserToUpgrade = () => {
    localStorage.setItem("token", loginToken);
    window.location.href = "/versionsInfo";
    removeLoginTokenLinkedIn();
  };

  return (
    <Modal
      centered
      show={showLinkedInIntegrationErrorModal}
      onHide={handleReturnToLinkedInTalentHub}
    >
      <Modal.Header closeButton style={{ borderBottom: "none" }}></Modal.Header>
      <Modal.Body className="mx-auto pt-0">
        <Row>
          <Col className="text-center">
            <div className="mb-3">
              <img
                src={criteriaLinkedInIntegrationImage}
                alt="criteria and linkedin logos"
              />
            </div>
            <h3 className="mb-3" style={{ fontSize: "16px" }}>
              {linkedInUserEmail}
            </h3>
            <p className="mb-4" style={{ color: "#828283", fontSize: "14px" }}>
              {linkedInErrorMessaging(linkedInIntegrationErrorMessage)}
            </p>
            <div>
              <Button
                variant="primary"
                style={{ minWidth: "200px" }}
                id="returnToLinkedInTalentHubBtn"
                className={
                  linkedInIntegrationErrorMessage === "ACCOUNT_NOT_ELIGIBLE"
                    ? "mb-1"
                    : "mb-3"
                }
                type="button"
                onClick={handleReturnToLinkedInTalentHub}
              >
                Return to LinkedIn Talent Hub
              </Button>
            </div>
            {linkedInIntegrationErrorMessage === "ACCOUNT_NOT_ELIGIBLE" && (
              <div>
                <Button
                  variant="outline-primary"
                  style={{ minWidth: "200px" }}
                  id="learnAboutUpgradingBtn"
                  className="mb-3"
                  type="button"
                  onClick={handleRouteUserToUpgrade}
                >
                  Learn More About Upgrading
                </Button>
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

LinkedInIntegrationErrorModal.propTypes = {
  showLinkedInIntegrationErrorModal: bool,
  linkedInUserEmail: string,
  linkedInIntegrationErrorMessage: string,
  loginToken: string,
};

export default LinkedInIntegrationErrorModal;
